import { useCurrentFrame, useVideoConfig } from "remotion";
import { FourierFilm } from "./FourierHeart";
import { penguinModel } from "./penguinModel";
import { penguinTheme } from "./penguinTheme";
import { PenguinArtwork } from "./PenguinArtwork";
import { getPenguinWaveAngle } from "./penguinWave";
import { getTimeline } from "./timeline";

const WavingPenguinArtwork = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const scene = getTimeline(frame, fps, penguinTheme.timing);
  return <PenguinArtwork wingAngle={getPenguinWaveAngle(
    scene.kind === "outro" ? scene.localFrame / fps : 0,
  )} />;
};

export const FourierPenguin = () => (
  <FourierFilm
    model={penguinModel}
    targetLabel="TRACED PENGUIN"
    centerFinal
    colors={penguinTheme.colors}
    timing={penguinTheme.timing}
    skipIntroCopy
    flatStyle
    finalArtwork={<WavingPenguinArtwork />}
    artworkReveal={{ delay: 0.3, duration: 0.45 }}
    outroText={["THIS IS", "FOURIER PENGUIN"]}
  />
);

